module.exports = __webpack_public_path__ + "static/media/wallpaper-salary-highway@3x.669ed717.png";